<template>
  <div>
    
    <v-form v-model="valid">
      <block v-if="loading"/>
        <v-card>
          <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
            <v-tabs-slider color="red"></v-tabs-slider>
            <v-tab href="#tab-1"  
            v-if="$store.getters['rolesUser/getCustomRole'](50)"
            @click="cleanData">
              AÑADIR TRASPASO
              <v-icon>mdi-archive-plus</v-icon>
            </v-tab>
            <v-tab href="#tab-2" 
            v-if="$store.getters['rolesUser/getCustomRole'](52)"
            @click="cleanData">
              AÑADIR SOLICITUD DE TRASPASO
              <v-icon>mdi-archive-edit</v-icon>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- Start of add transfer -->
            <v-tab-item value="tab-1">
              <v-card flat class="pa-1">
               
                  <div class="mt-0" style="
                      margin-top: 1.5rem;
                      display: flex;
                      justify-content: center;
                    ">
                    <v-col class="box" cols="12" md="12">
                      <v-row class="ml-2 mr-2" style="margin-top: 0.3rem">
                        <v-col cols="12" class="tabsNh">
                          <v-col cols="12" style="
                            display: flex;
                            justify-content: space-between;
                          ">
                            <div></div>
                            <div>
                              <v-btn small class="btnclean mr-1" @click.prevent="cleanData">
                                <v-icon>mdi-broom</v-icon>
                              </v-btn>
                              <v-btn v-if="$store.getters['rolesUser/getCustomRole'](51)" small class="mr-1 btn-save" @click.prevent.stop="addNewTransfer">
                                <v-icon v-if="requestStatus !== 3">mdi-content-save</v-icon>
                                <span v-else>Aceptar Recibo</span>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-col>
                      </v-row>

                      <div class=" flex-wrap align-self-center justify-space-between mb-4 pa-3 my-6">
                        <!-- Start of Form Add Transfer-->
                        <template>
                          <v-row>
                            <v-col cols="12" md="4" sm="12" lg="4" xl="4">
                              <date-picker :disabled="isReadonlyRequest" label="Fecha: " @dateSelected="(param) => (date = param)" v-model="date"
                                :value="date"></date-picker>
                            </v-col>
                              <v-col cols="12" md="4" sm="12" lg="4" xl="4">
                                <v-autocomplete attach :items="filteredWarehousesForOrigin" label="Almacén (Origen): "
                                  @change="getItemsFromWarehouseOrigin()" v-model="form.warehouseOrigin"
                                  item-text="Warehouse" item-value="ID_Warehouse"
                                  :disabled="productsToShow.length > 0 || productsToShowFilter.length > 0 || isReadonlyRequest" 
                                  outlined dense></v-autocomplete>
                              </v-col>

                              <v-col cols="12" md="4" sm="12" lg="4" xl="4">
                                <v-autocomplete attach :items="filteredWarehousesForDestination"
                                  label="Almacén (Destino): " v-model="form.warehouseDestination" item-text="Warehouse"
                                  item-value="ID_Warehouse" :disabled="isReadonlyRequest" outlined dense></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="12" sm="12" lg="10" xl="10" v-if="!isReadonlyRequest">
                                <v-autocomplete 
                                  attach 
                                  :items="searchResults.length > 0 ? searchResults : availableProductsForTransfer" 
                                  :search-input.sync="searchQuery"
                                  label="Buscar producto para agregar" 
                                  v-model="selectedProductToAdd"
                                  :disabled="!form.warehouseOrigin"
                                  @change="addProductFromDropdown"
                                  item-text="ItemName"
                                  item-value="ID_Inventory"
                                  :loading="searchLoading"
                                  outlined 
                                  dense
                                  clearable
                                  :auto-select-first="false"
                                  :menu-props="{ closeOnContentClick: true, auto: false }"
                                  :filter="searchResults.length > 0 ? () => true : customFilter"
                                  :no-data-text="searchQuery ? 'No se encontraron productos' : 'Escribe para buscar productos'"
                                >
                                  <template v-slot:selection>
                                    <span></span>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-list-item-avatar>
                                      <v-icon :color="item.ItemCurrentQuantity > 0 ? 'success' : 'error'">
                                        {{ item.ItemCurrentQuantity > 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                      </v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title :class="{ 'grey--text text-decoration-line-through': item.ItemCurrentQuantity <= 0 }">
                                        <strong>{{ item.ItemName }}</strong>
                                      </v-list-item-title>
                                      <v-list-item-subtitle>
                                        <v-chip x-small class="mr-1">ID: {{ item.ID_Item }}</v-chip>
                                        <v-chip x-small class="mr-1" :color="item.ItemCurrentQuantity > 0 ? '' : 'error'" :text-color="item.ItemCurrentQuantity > 0 ?'':'white'">
                                          Stock: {{ item.ItemCurrentQuantity }}
                                        </v-chip>
                                        <v-chip x-small class="mr-1">Almacén: {{ item.WarehouseName }}</v-chip>
                                        <v-chip x-small>Lote: {{ item.ID_ItemBatch || 'Por defecto' }}</v-chip>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="12" sm="12" lg="2" xl="2" v-if="!isReadonlyRequest" class="d-flex align-center">
                                <v-btn 
                                  class="btn-save float-right" 
                                  @click.prevent="showPrices = true"
                                  :disabled="!form.warehouseOrigin"
                                  small
                                >
                                  <v-icon small>mdi-format-list-bulleted</v-icon>
                                  <span class="ml-1 d-none d-md-inline">Agregar producto</span>
                                </v-btn>
                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col cols="12" md="12" class="mt-3">
                                <h3 :class="form.notes ? 'tabsContent' : 'tabs'" @click.prevent="showNotes = !showNotes"
                                  style="text-align: center;"> <v-icon class="icon-color">mdi-comment</v-icon> Comentarios

                                </h3>
                              </v-col>
                            </v-row>
                          <v-row class="mt-8">
                            <div><p><b>Indicación:</b> Editar celda (Unidades a transferir) para especificar la cantidad a transferir al almacén destino</p></div>
                              <!--v-col cols="12" class="d-flex flex-row-reverse">
                                <v-btn class="btn-save" @click="() => calculateStockResult('dxDataGridTransfer')">Calcular Nueva existencia</v-btn>
                              </v-col-->
                          </v-row>
                        </template>
                        <!-- End of Form Add Transfer -->
                        <!-- Datagrid Transfer Start -->
                        <GeneralFilter class="background border-box" entity="producto"
                        :filterEndpoint="filterTransferProduct" :search="search"
                        @emptyFilter="getProductsToShow" @filtered="filterHandler">
                          <DxDataGrid  
                            :allow-column-resizing="true" 
                            column-resizing-mode="widget"
                            :column-auto-width="true" 
                            ref="dxDataGridTransfer" 
                            :scrolling="{ useNative: true }" 
                            :data-source="productsToShow" 
                            key-expr="ID_Inventory" 
                            @exporting="onExporting"
                            >
                            <DxExport :enabled="true" />
                            <DxEditing :allow-updating="true" :select-text-on-edit-start="true" start-edit-action="click" mode="cell" />
                            <DxColumn :width=" columnWidth" :allow-editing="false" data-field="ID_Item" caption="ID de Producto"></DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="ItemName" caption="Nombre de Producto"></DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="WarehouseName" caption="Almacén (Origen)"></DxColumn>
                            <DxColumn  :width="columnWidth" :allow-editing="false" data-field="ItemCurrentQuantity" caption="Existencia actual"></DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="!isReadonlyRequest" data-field="CostoPromedio" caption="Costo Promedio"></DxColumn>
                            <DxColumn data-field="Amount" caption="Unidades a transferir" :allow-editing="!isReadonlyRequest" header-cell-template="headerNameAmount" data-type="number">
                              <DxValidator>
                              <DxPatternRule :pattern="itemQtyPattern"
                                message="La cantidad del producto solo puede contener numeros enteros mayores a 0" />
                              </DxValidator>
                              <DxAsyncRule :validation-callback="handleStockAndQty"
                                message="La cantidad del producto no puede exceder el stock actual en el almacen" />
                            </DxColumn>
                            <template #headerNameAmount="{}"><div>Unidades a<br/>transferir</div></template>
                            <DxColumn :width="columnWidth" :allow-editing="false" cell-template="stock-template" caption="Nueva existencia"></DxColumn>
                            <template #stock-template="{ data }">
                              {{ calculateCellValue(data.data) }}
                            </template>
                            <DxColumn   :width="columnWidth" cell-template="lote-template" caption="Lote"></DxColumn>
                            <template #lote-template="{ data }">
                              {{ data.data.ID_ItemBatch ? data.data.ID_ItemBatch : 'Por defecto' }}
                            </template>

                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="warehouseAtDestination" caption="Almacén (Destino)"></DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="ItemCurrentQuantityAtDestination" caption="Existencia actual"></DxColumn>
                            <DxColumn :width="columnWidth" cell-template="stock-template2" caption="Nueva existencia"></DxColumn>
                            <template #stock-template2="{ data }">
                              {{ calculateCellValue2(data.data) }}
                            </template>
                            <DxColumn   :width="columnWidth" cell-template="lote-template2" caption="Lote"></DxColumn>
                            <template #lote-template2="{ data }">
                              {{ data.data.ID_ItemBatchAtDestination ? data.data.ID_ItemBatchAtDestination : 'Por defecto' }}
                            </template>


                            <DxColumn :width="40" cell-template="show-template" caption="">
                            </DxColumn>
                            <template #show-template="{ data }">
                              <a href="#" class="mx-1" @click.prevent.stop="removeRow(data)">
                                <v-icon color="error">mdi-delete</v-icon>
                              </a>
                            </template>
                          </DxDataGrid>
                        </GeneralFilter>  
                        <!-- Datagrid Transfer End -->
                      </div>
                    </v-col>
                  </div>
              
              </v-card>
            </v-tab-item>
            <!-- End of add transfer -->
            <!-- Start of add request transfer -->
            <v-tab-item value="tab-2">
              <v-card flat class="pa-1">
             
                  <v-dialog v-model="showPriceList" width="60%">
                    <v-card class="pa-4">
                      <v-card-title style="
                          margin-top: 0.3rem;
                          margin-bottom: 0.3rem;
                          
                          ;
                        ">
                        <div class="text-h5">Lista de Precios</div>
                        <v-btn small class="btndelete" @click.prevent="showPriceList = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <!-- Needs filter -->
                        <DxDataGrid class="" :data-source="priceList" key-expr="id" :show-row-lines="showRowLines"  :scrolling="{ useNative: true }"
                          @exporting="onExportingP" :show-borders="showBorders"
                          :row-alternation-enabled="rowAlternationEnabled">
                          
                          <DxPaging :page-size="8" />
                          <DxExport :enabled="true" />
                          <DxColumn :width="60" cell-template="show-template" caption="">
                          </DxColumn>
                          <DxColumn :width="columnWidth" data-field="date" caption="Fecha de Creación"></DxColumn>
                          <DxColumn :width="columnWidth" data-field="id" caption="Nombre de la Lista de Precios"></DxColumn>
                          <DxColumn :width="columnWidth" v-if="rolesStatus.findIndex(
                            (role) => role.RoleName == 'admin'
                          ) > -1 ||
                            rolesStatus.findIndex(
                              (role) => role.RoleName == 'root'
                            ) > -1
                            " cell-template="actives-show" caption="Activo"></DxColumn>
                          <template #show-template="{ data }">
                            <a href="#" class="mx-1" @click.prevent.stop="
                              showProductOld(data)
                            showPriceList = false
                              ">
                              <v-icon> color="primary"</v-icon>
                            </a>
                          </template>
                          <template #actives-show="{ data }">
                            <div class="d-flex justify-center align-center" style="max-height: 30px">
                              <v-checkbox v-model="data.data.Active" @change="handleChanged(data.data)"></v-checkbox>
                            </div>
                          </template>
                        </DxDataGrid>
                      </v-card-text>
                    </v-card>
                  </v-dialog>

                  <div class="mt-0" style="
                      margin-top: 1.5rem;
                      display: flex;
                      justify-content: center;
                    ">
                    <v-col class="box" cols="12" md="12">
                      <v-row class="ml-2 mr-2" style="margin-top: 0.3rem">
                        <v-col cols="12" class="tabsNh">
                          <v-col cols="12" style="
                              display: flex;
                              justify-content: space-between;
                            ">
                            <div></div>
                            <div>
                              <v-btn small class="btnclean mr-1" @click.prevent="cleanData">
                                <v-icon>mdi-broom</v-icon>
                              </v-btn>
                              <v-btn v-if="$store.getters['rolesUser/getCustomRole'](53)" small class="mr-1 btn-save" @click.prevent.stop="addNewTransferRequest(0)">
                                <v-icon>mdi-content-save</v-icon>
                                Solicitar traspaso
                              </v-btn>
                              <v-btn v-if="$store.getters['rolesUser/getCustomRole'](53)" small class="mr-1" color="blue" dark @click.prevent.stop="addNewTransferRequest(3)">
                                <v-icon>mdi-truck-delivery</v-icon>
                                Solicitar envío
                              </v-btn>
                            </div>
                          </v-col>
                        </v-col>
                      </v-row>

                      <div class=" flex-wrap align-self-center justify-space-between mb-4 pa-3 my-6">
                        <!-- Start of Form Add Transfer-->
                        <template>
                          <v-col>
                            <v-row cols="12">
                              <v-col cols="12" md="4">
                                <date-picker label="Fecha: " @dateSelected="(param) => (date = param)" v-model="date"
                                  :value="date"></date-picker>
                              </v-col>

                              <v-col cols="12" md="4">
                                <v-autocomplete attach :items="filteredWarehousesForOrigin" v-model="form.warehouseOrigin"
                                  label="Almacén (Origen): " @change="getItemsFromWarehouseOrigin()" item-text="Warehouse"
                                  item-value="ID_Warehouse" :disabled="productsToShow.length > 0 || productsToShowFilter.length > 0"
                                  outlined dense></v-autocomplete>
                              </v-col>

                              <v-col cols="12" md="4">
                                <v-autocomplete attach :items="filteredWarehousesForDestination"
                                  v-model="form.warehouseDestination" label="Almacén (Destino): " item-text="Warehouse"
                                  item-value="ID_Warehouse" outlined dense></v-autocomplete>
                              </v-col>

                              <v-col cols="12" md="10">
                                <v-autocomplete 
                                  attach 
                                  :items="availableProductsForTransfer" 
                                  label="Seleccionar producto para agregar" 
                                  v-model="selectedProductToAdd"
                                  :disabled="!form.warehouseOrigin"
                                  @change="addProductFromDropdown"
                                  item-text="ItemName"
                                  item-value="ID_Inventory"
                                  outlined 
                                  dense
                                  clearable
                                  :auto-select-first="false"
                                  :menu-props="{ closeOnContentClick: true, auto: false }"
                                  :filter="customFilter"
                                  no-data-text="No hay productos en este almacén"
                                >
                                  <template v-slot:selection>
                                    <span></span>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-list-item-avatar>
                                      <v-icon :color="item.ItemCurrentQuantity > 0 ? 'success' : 'error'">
                                        {{ item.ItemCurrentQuantity > 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                      </v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title :class="{ 'grey--text text-decoration-line-through': item.ItemCurrentQuantity <= 0 }">
                                        <strong>{{ item.ItemName }}</strong>
                                        <v-chip v-if="item.ItemCurrentQuantity <= 0" x-small color="error" text-color="white" class="ml-2">
                                          Sin stock
                                        </v-chip>
                                      </v-list-item-title>
                                      <v-list-item-subtitle>
                                        <v-chip x-small class="mr-1">ID: {{ item.ID_Item }}</v-chip>
                                        <v-chip x-small class="mr-1" :color="item.ItemCurrentQuantity > 0 ? 'success' : 'error'" text-color="white">
                                          Stock: {{ item.ItemCurrentQuantity }}
                                        </v-chip>
                                        <v-chip x-small class="mr-1">Almacén: {{ item.WarehouseName }}</v-chip>
                                        <v-chip x-small>Lote: {{ item.ID_ItemBatch || 'Por defecto' }}</v-chip>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-btn 
                                  class="btn-save float-right" 
                                  @click.prevent="showPrices = true"
                                  :disabled="!form.warehouseOrigin"
                                  small
                                >
                                  <v-icon small>mdi-format-list-bulleted</v-icon>
                                  <span class="ml-1 d-none d-md-inline">Agregar producto</span>
                                </v-btn>
                              </v-col>

                            </v-row>

                            <v-row cols="12">
                              <v-col cols="12" md="12" class="mt-3">
                                <h3 :class="form.notes ? 'tabsContent' : 'tabs'" @click.prevent="showNotes = !showNotes"
                                  style="text-align: center;"> <v-icon class="icon-color">mdi-comment</v-icon> Comentarios

                                </h3>
                              </v-col>
                            </v-row>
                            <v-row class="mt-8">
                              <div><p><b>Indicación:</b> Editar celda (Unidades a transferir) para especificar la cantidad a transferir al almacén destino</p></div>
                              <!--v-col cols="12" class="d-flex flex-row-reverse">
                                <v-btn class="btn-save" @click="() => calculateStockResult('dxDataGridRequest')">Calcular Nueva existencia</v-btn>
                              </v-col-->
                            </v-row>
                          </v-col>
                        </template>
                        <!-- End of Form Add Transfer -->
                        <!-- Datagrid Transfer Start -->
                        <GeneralFilter class="background border-box" entity="producto"
                        :filterEndpoint="filterTransferProduct" :search="search"
                        @emptyFilter="getProductsToShow" @filtered="filterHandler">
                          <DxDataGrid class="isScrolledByGeneralFilter" ref="dxDataGridRequest" :key="renderN" :data-source="productsToShow" key-expr="ID_Inventory"
                            @exporting="onExporting">
                            <DxExport :enabled="true" />
                            <DxEditing :allow-updating="true" :select-text-on-edit-start="true" start-edit-action="click"
                              mode="cell" />
                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="ID_Item" caption="ID de Producto">
                            </DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="ItemName" caption="Nombre de Producto">
                            </DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="ItemCurrentQuantity" caption="Existencia actual"></DxColumn>
                            <DxColumn :width="columnWidth" :allow-editing="true" data-field="CostoPromedio" caption="Costo Promedio"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="Amount" caption="Unidades a transferir" cell-header-template="headerNameAmount"  data-type="number">
                              <DxPatternRule :pattern="itemQtyPattern"
                                message="La cantidad del producto solo puede contener numeros enteros mayores a 0" />
                              <DxAsyncRule :validation-callback="handleStockAndQty"
                                message="La cantidad del producto no puede exceder el stock actual en el almacen" />
                            </DxColumn>
                            <template #headerNameAmount="{}"><div>Unidades a<br/>transferir</div></template>
                            <DxColumn :width="columnWidth" cell-template="stock-template" caption="Nueva existencia"></DxColumn>
                            <template #stock-template="{ data }">
                              {{ calculateCellValue(data.data) }}
                            </template>
                            <DxColumn   :width="columnWidth" cell-template="lote-template" caption="Lote"></DxColumn>
                            <template #lote-template="{ data }">
                              {{ data.data.ID_ItemBatch ? data.data.ID_ItemBatch : 'Por defecto' }}
                            </template>

                            <DxColumn :width="columnWidth" :allow-editing="false" data-field="warehouseAtDestination" caption="Almacén (Destino)"></DxColumn>
                            <DxColumn  :width="columnWidth" :allow-editing="false" data-field="ItemCurrentQuantityAtDestination" caption="Existencia actual"></DxColumn>
                            <DxColumn   :width="columnWidth" cell-template="stock-template2" caption="Nueva existencia"></DxColumn>
                            <template #stock-template2="{ data }">
                              {{ calculateCellValue2(data.data) }}
                            </template>
                            <DxColumn   :width="columnWidth" cell-template="lote-template2" caption="Lote"></DxColumn>
                            <template #lote-template2="{ data }">
                              {{ data.data.ID_ItemBatchAtDestination ? data.data.ID_ItemBatchAtDestination : 'Por defecto' }}
                            </template>


                            <DxColumn :width="40" cell-template="show-template" caption="">
                            </DxColumn>
                            <template #show-template="{ data }">
                              <a href="#" class="mx-1" @click.prevent.stop="removeRow(data)">
                                <v-icon color="error">mdi-delete</v-icon>
                              </a>
                            </template>
                          </DxDataGrid>
                        </GeneralFilter>  
                        <!-- Datagrid Transfer End -->
                        <!-- Needs filter -->
                        <!-- <DxDataGrid class="isScrolledByGeneralFilter" :data-source="productsToShow" key-expr="ID_Item" :show-row-lines="showRowLines"
                          @exporting="onExportingLP" :show-borders="showBorders"
                          :row-alternation-enabled="rowAlternationEnabled">
                          <DxExport :enabled="true" />
                          <DxEditing :allow-updating="true" :select-text-on-edit-start="true" start-edit-action="click"
                            mode="cell" />
                            <DxColumn data-field="ID_Item" caption="ID de Producto"></DxColumn>
                            <DxColumn data-field="ItemName" caption="Nombre de Producto"></DxColumn>
                            <DxColumn data-field="Amount" :allow-editing="true" caption="Cantidad Solicitada"></DxColumn>
                            <DxColumn cell-template="stock-template" caption="Stock Origen Resultante"></DxColumn>
                            <template #stock-template="{ data }">
                              {{ data.data.ItemCurrentQuantity }} {{ data.data.ItemMeasureUnit }}
                            </template>
                          <DxColumn v-if="rolesStatus.findIndex(
                            (role) => role.RoleName == 'admin'
                          ) > -1 ||
                            rolesStatus.findIndex(
                              (role) => role.RoleName == 'root'
                            ) > -1 ||
                            rolesStatus.findIndex(
                              (role) => role.ID_Role == 45
                            ) > -1
                            " :width="40" cell-template="show-template" caption=""></DxColumn>

                          <template #show-template="{ data }">
                            <a href="#" class="mx-1" @click.prevent.stop="removeRow(data)">
                              <v-icon color="error">mdi-delete</v-icon>
                            </a>
                          </template>

                          <template #product-discount="{ data }">
                            <div class="input-group">
                              <input type="number" v-model="data.data.ItemPriceDiscountAmount"
                                :max="data.data.ItemOriginalPrice" min="0" @keyup.enter="changeDis($event, data)"
                                class="form-control" />

                              <div class="input-group-prepend">
                                <span class="input-group-text">{{
                                  CurrentBranch.Currency
                                }}</span>
                              </div>
                            </div>
                          </template>

                          <template #product-discountpercent="{ data }">
                            <div class="input-group">
                              <input type="number" v-model="data.data.ItemPriceDiscountPercent" class="form-control"
                                @keyup.enter="changeDisP($event, data)" :max="100" :min="0" />
                              <div class="input-group-prepend">
                                <span class="input-group-text">%</span>
                              </div>
                            </div>
                          </template>

                        </DxDataGrid> -->
                      </div>
                    </v-col>
                  </div>
                
              </v-card>
            </v-tab-item>
            <!-- End of add request transfer -->
          </v-tabs-items>
        </v-card>
      </v-form>
  
    <v-dialog v-model="showPrices" width="80%" scrollable>
      <v-card class="pa-4">
        <v-card-title class="text-h5">
          Productos agregados {{ counter }}
        </v-card-title>
        <v-card-text>
          <v-dialog v-model="showFilter" width="800" persistent scrollable>
            <v-card>
              <v-card-text>
                <v-row >
                  <v-col cols="12" md="12" sm="12" style="
                      display: flex;
                      justify-content: space-between;
                      margin-top: 1rem;
                    ">
                    <div class="text-h5">Filtrar Productos</div>
                    <v-btn @click.prevent="clearFilters" class="btnclean">
                      Limpiar Filtros
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete outlined dense label="proveedor" v-model="filter.providers" :items="warehouses"
                          item-text="ProviderName" attach item-value="ID_Provider"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete outlined dense label="Familia" v-model="filter.family" :items="families"
                          item-text="name" attach item-value="id"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete outlined dense label="Categoría" v-model="filter.category"
                          :items="filteredCategories" item-text="name" attach item-value="id"
                          :disabled="!filter.family"></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-autocomplete outlined dense label="Subcategoría" v-model="filter.subcategory"
                          :items="filteredSubcategories" attach item-text="name" item-value="id"
                          :disabled="!filter.category"></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" style="
                      display: flex;
                      justify-content: flex-end;
                      margin-top: 0.6rem;
                    ">
                    <v-btn @click.prevent="filterProductsDt" class="btn-save">
                      Aplicar Filtros
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
          <div style="display: flex; justify-content: flex-start; padding: 12px">
            <v-btn v-if="showdeselect" class="btn-save" @click="deselectAll">Deseleccionar todas</v-btn>
            <v-btn v-else @click="selectAll" class="btn-save">Seleccionar todas</v-btn>
            &nbsp;&nbsp;<v-btn class="btn-save" @click.prevent="addProducts">Agregar</v-btn>  
          </div>
          <div style="width: 97%;">
            <!-- Hidden -->
            <div v-show="false" style="margin-left: 0.3rem">
              <v-btn class="fs-14 mx-2 btnclean" style="margin-top: 1rem; position: fixed; z-index: 50"
                @click.prevent.stop="showFilter = !showFilter">
                Filtrar</v-btn>
            </div>
            <VersatileFilter :columnsSearch="columsConfig" :disableDates="true"  ref="generalFilter" :search="{}" :extraParam1="form.warehouseOrigin" :columnfilterEndpoint="$API.products.getProductInventoryHistoryByColumns" @emptyFilter="clearInventoryFilter" @filtered="handleInventoryFilter">
              <DxDataGrid class="" :data-source="inventory" key-expr="ID_Inventory" :show-row-lines="showRowLines" @exporting="onExporting"
                :show-borders="showBorders" :row-alternation-enabled="rowAlternationEnabled" 
                :scrolling="{ useNative: true }"
                      :column-auto-width="true"
                >
                <DxExport :enabled="true" />
    
              
                <DxColumn  cell-template="show-template" caption=""></DxColumn>
                <DxPaging :page-size="5" />
                <DxColumn :width="columnWidth" data-field="ID_Item" caption="ID de Producto/Servicio"></DxColumn>
                <DxColumn :width="columnWidth" data-field="PrincipalBarCode" caption="Código Alterno Principal"></DxColumn>
                <DxColumn :width="columnWidth" data-field="WarehouseName" caption="Almacen"></DxColumn>
                <DxColumn :width="columnWidth" cell-template="stock-template" caption="Existencia"></DxColumn>
                <DxColumn :width="columnWidth" cell-template="lote-template" caption="lote"></DxColumn>
                <DxColumn data-field="ItemName" caption="Nombre de Producto/Servicio"></DxColumn>
                <template #show-template="{ data }">
                  <div class="d-flex justify-center align-center" style="height: 100%;">
                    <div v-if="data.data.ItemCurrentQuantity <= 0">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon 
                            color="error" QUe
                            v-bind="attrs" 
                            v-on="on"
                            size="20"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>Sin existencia disponible</span>
                      </v-tooltip>
                    </div>
                    <div v-else-if="data.data.Warehouse != form.warehouseOrigin">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon 
                            color="warning" 
                            v-bind="attrs" 
                            v-on="on"
                            size="20"
                          >
                            mdi-information
                          </v-icon>
                        </template>
                        <span>Solo se pueden seleccionar productos del almacén de origen</span>
                      </v-tooltip>
                    </div>
                    <v-checkbox 
                      v-else
                      v-model="data.data.checkbox" 
                      class="pt-0 mt-0" 
                      hide-details
                      @click="showProduct(data)">
                    </v-checkbox>
                  </div>
                </template>
                <template #stock-template="{ data }">
                  {{ data.data.ItemCurrentQuantity }} {{ data.data.ItemMeasureUnit }}
                </template>
                <template #lote-template="{ data }">
                  {{ data.data.ID_ItemBatch ? data.data.ID_ItemBatch : "Por defecto" }}
                </template>
              </DxDataGrid>
            </VersatileFilter>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="60%" v-model="showNotes">
      <v-card class="pa-4">
        <div style="margin-top: .3rem;margin-bottom: .3rem; display: flex;justify-content: flex-end;">
          <v-btn small class="btndelete" @click.prevent="showNotes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <quill-editor ref="quillEditor" :disabled="isReadonlyRequest" :content="form.comments" :options="quillOptions" @change="onEditorChange($event)"></quill-editor>
      </v-card>
    </v-dialog>

    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>

  </div>
</template>

<script>
import Block from "@/components/Block.vue";

import {
  DxDataGrid,
  DxColumn,
 
  DxPaging,
  DxExport,
  DxEditing,
  DxPatternRule,
  DxAsyncRule,
  DxValidator
} from 'devextreme-vue/data-grid'
import DatePicker from "@/components/DatePicker.vue"
import Alerts from '@/components/Alerts'
import { mapMutations, mapState } from 'vuex'
import { printToExcel } from '@/helpers/printToexcel'
import { quillConfig } from "@/helpers/quillconfig"
// eslint-disable-next-line no-unused-vars
import {fixFormatDate } from '@/helpers/formatDate'
import VersatileFilter from '@/components/VersatileFilter';
import { getUUIDv4 } from '@/helpers/misc'

import GeneralFilter from '@/components/GeneralFilter.vue'
import { vesatileCriteriaFilter } from '../../../helpers/object'

export default {
  name: "AddTransferC",
  components: {
    DxDataGrid,
    VersatileFilter,
    DxPatternRule,
    DxColumn,
    DxValidator,
    DxAsyncRule,
  
    DxPaging,
    Alerts,
    DxExport,
    DatePicker,
    DxEditing,
    GeneralFilter,
    Block
  },
  props: ['win'],

  data() {
    return {
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        options: null,
      },
      valid: false,
      loading: false,
      showNotes: false,
      showPrices: false,
      showPriceList: false,
      showRelateClientPrice: false,
      productsprev: [],
      tab: null,
      panel: 0,
      quillOptions: quillConfig,
      checkbox: true,
      discountpercent: 0,
      form: {
        warehouseDestination: null,
        warehouseOrigin: null,
        typeOfTransfer: null,
        Active: false,
        notes: null,
        comments: null,
        pricelistname: null
      },
      exportData: false,
      priceList: [],
      showList: false,
      productsToBill: [],
      inventory: [],
      productsToShow: [],
      productsToShowOld: [],
      productsToShowWarehouse: [],
      filterProducts: {},
      items: [],
      filter: {
        family: null,
        category: null,
        subcategory: null,
        providers: null,
      },
      columsConfig: [
                {
                    name: "PR.family",
                    title: "Familia",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "PR.category",
                    title: "Categoría",
                    value: "",
                    parent: 'PR.family',
                    type: "select",
                    options: [],
                },
                {
                    name: "PR.subcategory",
                    title: "Subcategoría",
                    value: "",
                    parent: 'PR.category',
                    type: "select",
                    options: [],
                },
      ],
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      business: null,
      branch: null,
      showdeselect: false,
      counter: 0,
      showFilter: false,
      families: [],
      categories: [],
      subcategories: [],
      providers: [],
      renderN: 0,
      customers: [],
      search: {
        filter: null
      },
      date: null,
      selectedClient: {},
      selectedProductToAdd: null,
      searchQuery: '',
      searchResults: [],
      searchLoading: false,
      searchTimeout: null,
      warehouses: [],
      filterWarehouses: {},
      products: [],
      AllData: [],
      typeOfTransfer: ["Pendientes", "Parcialmente servidas", "Servidas", "Finalizadas", "Otros"],
      itemQtyPattern: /^(0|[1-9]\d*)$/,
      transferRequestActive: false,
      requestStatus: null,
      requestId: null,
      productsToShowFilter: [],
      isInventoryFiltered: false,
      inventoryFiltered: [],
      didHaveAllData: false
    }
  },
  watch: {
    transferRequestData: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if(newValue.tab == "request"){
            this.tab = "tab-1"
          }
          // Cargar datos inmediatamente sin esperar NADA
          this.fillDataFromTransferOptimized()
          // NO cargar inventario aquí - se cargará bajo demanda cuando sea necesario
        }
      }
    },
    showPrices: function (newValue, oldValue) {
      if (!newValue) {
        this.inventory.map((element) => {
          element.checkbox = false
        })
        // this.showpriceskey++
        this.counter = 0
      }
      console.log(oldValue)
    },
    'form.warehouseOrigin': function (newValue, oldValue) {
      // Cuando cambie el almacén de origen, actualizar la lista de productos
      if (this.productsToShowWarehouse && this.productsToShowWarehouse.length > 0) {
        this.getItemsFromWarehouseOrigin()
      }
      console.log('Warehouse origin changed:', oldValue, '->', newValue)
    },
    'form.warehouseDestination': function (newValue, oldValue) {
      // Cuando cambie el almacén de destino, actualizar la lista de productos
      if (this.productsToShowWarehouse && this.productsToShowWarehouse.length > 0) {
        this.getItemsFromWarehouseOrigin()
      }
      console.log('Warehouse destination changed:', oldValue, '->', newValue)
    },
    searchQuery: function (val) {
      // Búsqueda dinámica desde el backend
      if (!val || val.length < 3) {
        this.searchResults = []
        return
      }

      // Cancelar búsqueda anterior si existe
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      // Debounce: esperar 600ms después de que el usuario deje de escribir
      this.searchTimeout = setTimeout(() => {
        this.searchProductsFromBackend(val)
      }, 600)
    }
  },
  computed: {
    ...mapState(
      "rolesUser",
      {
        rolesStatus: (state) => state.roles,
      })
      ,
    ...mapState({
      currentBranch: 'CurrentBranch',
      transferRequestData: state => state.transferData.transfers,
      reloadState: state => state.transferData.reloadData,
    }),
    columnWidth() {
    return '160px'
  },
    filteredCategories() {
      return this.filter.family
        ? this.categories.filter(
          (category) => category.id_family == this.filter.family
        )
        : []
    },
    filteredSubcategories() {
      return this.filter.category
        ? this.subcategories.filter(
          (subcategory) => subcategory.id_cat == this.filter.category
        )
        : []
    },
    filteredWarehousesForOrigin() {
      return this.warehouses.filter(
        (warehouse) => warehouse.ID_Warehouse != this.form.warehouseDestination
      )
    },
    filteredWarehousesForDestination() {
      return this.warehouses.filter(
        (warehouse) => warehouse.ID_Warehouse != this.form.warehouseOrigin
      )
    },
    isReadonlyRequest() {
      return this.transferRequestData && this.transferRequestData.RequestStatus === 3
    },
    availableProductsForTransfer() {
      if (!this.form.warehouseOrigin) {
        return []
      }
      // Filtrar productos que están en el almacén origen y que NO están ya agregados
      const addedInventoryIds = this.productsToShow.map(p => p.ID_Inventory)
      return this.inventory
        .filter(product => {
          // Solo productos del almacén origen que no estén ya agregados
          return product.Warehouse === this.form.warehouseOrigin && 
                 !addedInventoryIds.includes(product.ID_Inventory)
        })
        .map(product => ({
          ...product,
          // Indicador visual de disponibilidad
          displayText: `${product.ItemName} (Stock: ${product.ItemCurrentQuantity})`,
          canAdd: product.ItemCurrentQuantity > 0,
          disabled: product.ItemCurrentQuantity <= 0
        }))
    },
    ...mapState('rolesUser', {
      rolesStatus: (state) => state.roles,
    }),
    isCarsem(){
      return [
              'f33722a12f5e692b30374bbcf86011db'
              //,'0636d70779280489c228f2bd3aa0ff95'
            ].includes(JSON.parse(localStorage.getItem('user'))?.keymaster);
    }
  },
  mounted() {
    // Establecer fecha actual al montar el componente en formato dd/mm/yyyy
    const today = new Date()
    const day = String(today.getDate()).padStart(2, '0')
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const year = today.getFullYear()
    this.date = `${day}/${month}/${year}`
    
    this.$store.dispatch('rolesUser/getAllRoles')
    this.business =
      JSON.parse(localStorage.getItem('user')).businessid != undefined
        ? JSON.parse(localStorage.getItem('user')).businessid
        : 0
    this.branch =
      JSON.parse(localStorage.getItem('user')).branch != undefined
        ? JSON.parse(localStorage.getItem('user')).branch
        : 0
    this.filterProducts = {
      filter: 'pricelist',
      business: this.business,
      branch: this.branch,
    }
    // Desuso de endpoint innecesarios para transferencias
    //this.getAllPriceList()
    this.getProducts()
    this.getInventory()
    //this.getAllProducts()
    //this.getFamilies()
    //this.getCategories()
    //this.getSubs()
    //this.getAllProviders()
    this.search.business = JSON.parse(localStorage.getItem('user')).businessid
    this.search.branch = JSON.parse(localStorage.getItem('user')).branch
    this.search.type = 0
    this.getFamilies();
    this.getCategories();
    this.getSubs();
    //this.getCustomers()
    this.getWarehouse()
    // fillDataFromTransferOptimized() se ejecuta solo cuando hay cambios en transferRequestData (watch)
  },

  methods: {
    async searchProductsFromBackend(searchTerm) {
      if (!this.form.warehouseOrigin) {
        this.searchResults = []
        return
      }

      this.searchLoading = true
      try {
        const params = {
          warehouse: this.form.warehouseOrigin,
          fecha: this.date || new Date().toISOString().split('T')[0],
          like: searchTerm
        }
        
        console.log('Buscando productos en backend con término:', searchTerm)
        const response = await this.$API.products.getInventorySearchForTransfer(params)
        console.log('Respuesta del backend:', response)
        
        // Mapear los datos del nuevo endpoint al formato esperado
        this.searchResults = response.map(product => ({
          ID_Inventory: product.ID_Inventory,
          ID_Item: product.ID_Item,
          ItemName: product.ItemName,
          ID_ItemBatch: product.ID_ItemBatch,
          ItemCurrentQuantity: product.ItemCurrentQuantity || 0,
          Warehouse: product.Warehouse,
          WarehouseName: product.WarehouseName,
          ItemMeasureUnit: product.ItemMeasureUnit,
          PrincipalBarCode: product.PrincipalBarCode,
          CostoPromedio: product.CostoPromedio || 0,
          canAdd: (product.ItemCurrentQuantity || 0) > 0
        }))
        
        console.log('Resultados filtrados:', this.searchResults.length, 'productos')
      } catch (error) {
        console.error('Error al buscar productos:', error)
        this.searchResults = []
      } finally {
        this.searchLoading = false
      }
    },
    customFilter(item, queryText) {
      const searchText = queryText.toLowerCase()
      return item.ItemName?.toLowerCase().includes(searchText) ||
             item.ID_Item?.toLowerCase().includes(searchText) ||
             item.ID_ItemBatch?.toLowerCase().includes(searchText)
    },
    async addProductFromDropdown() {
      if (!this.selectedProductToAdd) return
      
      // Buscar el producto en searchResults primero, luego en availableProductsForTransfer
      let productToAdd = this.searchResults.find(p => p.ID_Inventory === this.selectedProductToAdd)
      
      if (!productToAdd) {
        productToAdd = this.availableProductsForTransfer.find(p => p.ID_Inventory === this.selectedProductToAdd)
      }
      
      if (!productToAdd) {
        console.error('Producto no encontrado:', this.selectedProductToAdd)
        this.selectedProductToAdd = null
        this.searchQuery = ''
        this.searchResults = []
        return
      }

      console.log('Producto a agregar:', productToAdd)

      // Validación 1: Verificar que el producto sea del almacén origen
      if (productToAdd.Warehouse !== this.form.warehouseOrigin) {
        this.showAlert(
          'warning',
          'Advertencia',
          'Solo puedes agregar productos del almacén de origen seleccionado'
        )
        this.selectedProductToAdd = null
        return
      }

      // Validación 2: Verificar que tenga stock disponible
      if (productToAdd.ItemCurrentQuantity <= 0) {
        this.showAlert(
          'warning',
          'Advertencia',
          `El producto "${productToAdd.ItemName}" no tiene stock disponible en el almacén de origen`
        )
        this.selectedProductToAdd = null
        return
      }

      // Validación 3: Verificar que no esté ya agregado
      const alreadyAdded = this.productsToShow.find(p => p.ID_Inventory === productToAdd.ID_Inventory)
      if (alreadyAdded) {
        this.showAlert(
          'warning',
          'Advertencia',
          `El producto "${productToAdd.ItemName}" ya está agregado a la lista`
        )
        this.selectedProductToAdd = null
        return
      }

      // Obtener información del producto en el almacén destino
      let destinationInfo = { ItemCurrentQuantity: 0 }
      if (this.form.warehouseDestination) {
        try {
          destinationInfo = await this.$API.inventoryTransfer.infoProductAtDestination({
            warehouse: this.form.warehouseDestination,
            id_itembatch: productToAdd.ID_ItemBatch,
            id_item: productToAdd.ID_Item,
          })
        } catch (error) {
          console.log('Error getting destination info:', error)
        }
      }

      // Agregar el producto a la lista usando el mismo patrón que addProducts (spread operator)
      this.productsToShow.push({
        ...productToAdd,
        _uuid: getUUIDv4(),
        Amount: 0,
        StockResult: productToAdd.ItemCurrentQuantity,
        warehouseAtDestination: this.warehouses.find(w => w.ID_Warehouse === this.form.warehouseDestination)?.Warehouse || '',
        ItemCurrentQuantityAtDestination: destinationInfo.ItemCurrentQuantity || 0,
        StockResultAtDestination: destinationInfo.ItemCurrentQuantity || 0,
        ID_ItemBatchAtDestination: destinationInfo.ID_ItemBatch || 'Por defecto',
        CostoPromedio: productToAdd.CostoPromedio || 0
      })

      // Guardar productos (igual que addProducts)
      this.saveProductsToShow()

      // Limpiar selección y búsqueda
      this.selectedProductToAdd = null
      this.searchQuery = ''
      this.searchResults = []
      
      // Refrescar el grid
      this.$nextTick(() => {
        if (this.$refs['dxDataGridTransfer']) {
          this.$refs['dxDataGridTransfer'].instance.refresh()
        }
        if (this.$refs['dxDataGridRequest']) {
          this.$refs['dxDataGridRequest'].instance.refresh()
        }
      })
    },
    // getFamilies() {
    //   this.$API.itemtypes.getFamiliesHistory().then((response) => {
    //     this.columsConfig[0].options = response;
    //   });
    // },
    // getCategories() {
    //   this.$API.itemtypes.getCategoriesHistory().then((response) => {
    //     this.columsConfig[1].options = response;
    //   });
    // },
    // getSubs() {
    //   this.$API.itemtypes.getSubsHistory().then((response) => {
    //     this.columsConfig[2].options = response;
    //   });
    // },
    // async selectFamily() {
    //   this.filteredCategories = await this.$API.itemtypes.getCategoriesByFamily( { id_family: this.form.family } );
    // },
    // async selectCategory() {
    //   this.filteredSubcategories = await this.$API.itemtypes.getSubsByCategory( { id_cat: this.form.category } );
    // },
    clearInventoryFilter() {
      // this.isInventoryFiltered = false;
      this.getInventory();
      this.getItemsFromWarehouseOrigin()
    },
    handleInventoryFilter(response) {
      if (response.length === 0 && this.didHaveAllData === false) {
        this.didHaveAllData = true;
        this.getInventoryListAll();
        this.$refs.generalFilter.filterHandler();
      }
      // this.isInventoryFiltered = true;
      //Filtering inventoryList by warehouse origin only
      if (this.form.warehouseOrigin) {
        this.inventory = response.filter(product => {
          return product.Warehouse == this.form.warehouseOrigin
        });
      } else {
        this.inventory = []
      }
      
      // add a checkbox to each product
      this.inventory.forEach((product) => {
        if (product.checkbox === undefined) {
          product.checkbox = false
        }
      })
      //Filtering again inventory
      // this.getItemsFromWarehouseOrigin()
    },
    filterInventoryPromise(filterObj) {
      const filterArray =[
        "ID_Item",
        "ItemName",
        "WarehouseName",
        "ItemCurrentQuantity",
        "ItemMeasureUnit",
      ];
      return new Promise((resolve, reject) => {
        try {
          resolve(vesatileCriteriaFilter(filterArray, filterObj, this.inventory));
        } catch (error) {
          reject(error);
        }
      });
    },
    ...mapMutations({
      setReload: 'transferData/setReload'
    }),
    calculateStockResult(ref){
      for( const i in this.productsToShow ){
        this.productsToShow[i].StockResult = this.productsToShow[i].ItemCurrentQuantity - this.productsToShow[i].Amount;
      }
      this.$refs[ref].instance.refresh();
      // this.$refs['dxDataGridRequest'].instance.refresh();
    },
    onEditorChange(e) {
      this.form.comments = e.html
    },
    async handleStockAndQty(params) {
      try {
        var { value, data: { ItemCurrentQuantity } } = params

        if (value > ItemCurrentQuantity) {
          return false
        }
        
        for( const i in this.productsToShow ){
          this.productsToShow[i].StockResult = this.productsToShow[i].ItemCurrentQuantity - this.productsToShow[i].Amount;
        }

        return true
      } catch (error) {
        this.alert.show('danger', 'Error', `Ocurrio el siguiente error al intentar manejar el stock del producto ${error.message}`)
      }
    },
    calculateCellValue(data) {
      data.StockResult = data.ItemCurrentQuantity - data.Amount
      return data.StockResult
    },
    calculateCellValue2(data) {
      data.StockResultAtDestination = data.ItemCurrentQuantityAtDestination + data.Amount
      return data.StockResultAtDestination
    },
    async itemsQtyOnlyDigits(params) {
      try {
        const retorno = this.itemQtyPattern.test(params.value)
        return retorno
      } catch (error) {
        this.alert.show('danger', 'Error', `Ocurrio el siguiente error al intentar validar la cantidad del producto ${error.message}`)
      }
    },
    getCustomers() {
      this.$API.customers.getCustomers(this.search).then((response) => {
        this.customers = response
      })
    },
    onExporting(e) {
      printToExcel(e, 'Lista de Precios ')
    },
    async onExportingLP() {
      this.exportN()
      this.exportData = true
    },
    async exportN() {
      this.exportData = true
      setTimeout(() => {
        const data = this.$refs.priceListref.instance
        printToExcel({ component: data }, 'Lista de Productos')
      }, 200)
      setTimeout(() => {
        this.exportData = false
      }, 300)
    },
    onExportingP(e) {
      printToExcel(e, 'Lista de Traspasos')
    },
    filterProductsDt() {
      this.productsToBill = this.productsToShowOld
      if (this.filter.family != null) {
        this.productsToBill = this.productsToBill.filter(
          (product) => product.id_family == this.filter.family
        )
      }
      if (this.filter.category != null) {
        this.productsToBill = this.productsToBill.filter(
          (product) => product.id_cat == this.filter.category
        )
      }
      if (this.filter.subcategory != null) {
        this.productsToBill = this.productsToBill.filter(
          (product) => product.id_subcat == this.filter.subcategory
        )
      }
      if (this.filter.providers != null) {
        this.productsToBill = this.productsToBill.filter(
          (product) => product.ID_Provider == this.filter.providers
        )
      }
      this.showFilter = false
    },
    clearFilters() {
      this.filter.family = null
      this.filter.category = null
      this.filter.subcategory = null
      this.filter.providers = null
      this.productsToBill = this.productsToShowOld
    },
    async addProducts() {
      // Solo agregar productos del almacén de origen (no del destino)
      this.inventory.forEach((element) => {
        if (element.checkbox && element.ItemCurrentQuantity > 0 && element.Warehouse == this.form.warehouseOrigin) {
          this.productsprev.push(element)
        }
      })

      for (const element of this.productsprev) {
        if (!this.productsToShow.find((i) => i.ID_Inventory == element.ID_Inventory)) {
          let result = await this.$API.inventoryTransfer.infoProductAtDestination({
            warehouse: this.form.warehouseDestination,
            id_itembatch: element.ID_ItemBatch,
            id_item: element.ID_Item
          });

          let warehouseAtDestination = this.warehouses.find((warehouse) => warehouse.ID_Warehouse == this.form.warehouseDestination).Warehouse

          this.productsToShow.push({ ...element, _uuid: getUUIDv4(), Amount: 0, StockResult: element.ItemCurrentQuantity, 
            warehouseAtDestination: warehouseAtDestination, ItemCurrentQuantityAtDestination: result.ItemCurrentQuantity || 0, StockResultAtDestination: result.ItemCurrentQuantity || 0, ID_ItemBatchAtDestination: result.ID_ItemBatch || 'Por defecto', CostoPromedio: element.CostoPromedio || 0 }) // <== HERE
        }
      }

      // Saving added products for transfer
      this.saveProductsToShow()

      //  this.productsToShow.push(...this.productsprev);
      this.inventory.map((element) => {
        element.checkbox = false
      })
      this.counter = 0
      this.showPrices = false
      this.showpriceskey++
      this.productsprev = []
    },

    closeAlert() {
      // El aviso de tienda (tipo warning) cierra con closeAlert: igual exporta el PDF del traspaso.
      if (this.alert.options && typeof this.alert.options.alertAccept === 'function') {
        return this.acceptAlert()
      }
      this.alert.show = false
    },

    reload() {
      this.getAllPriceList()
      this.getProducts()
      setTimeout(() => {
        window.scrollTo(0, this.$store.getters.getScrollTop)
        //alert(this.$store.getters.getScrollTop)
      }, 300)
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? 'danger' : type
      this.alert.type = type
      this.alert.header = header
      this.alert.body = body
      this.alert.show = true
      this.alert.options = options != null ? options : null
    },
    resolveTransferResponse(response) {
      const queue = [response]

      while (queue.length > 0) {
        const current = queue.shift()

        if (!current || typeof current !== 'object') {
          continue
        }

        if (current.ID_Transfer || current.ID_Request) {
          return current
        }

        if (current.transfer && current.transfer !== current) {
          queue.push(current.transfer)
        }

        if (current.inventorytransfer && current.inventorytransfer !== current) {
          queue.push(current.inventorytransfer)
        }

        if (current.data && current.data !== current) {
          queue.push(current.data)
        }
      }

      return response
    },
    hasCompleteTransferPdfData(transfer) {
      if (!transfer || typeof transfer !== 'object') {
        return false
      }

      const details = Array.isArray(transfer.details) ? transfer.details : []
      const hasCompleteDetails =
        details.length > 0 &&
        details.every((item) =>
          item &&
          item.ID_Item != null &&
          item.ItemBarCode != null &&
          item.ItemName != null &&
          item.CantidadSolicitada != null &&
          item.CostoPromedio != null &&
          item.StockOrigenResultante != null &&
          item.StockDestinoResultante != null
        )

      return Boolean(
        transfer.OriginWarehouse &&
          transfer.DestinyWarehouse &&
          hasCompleteDetails &&
          (transfer.userName || transfer.ReqName || transfer.ID_User)
      )
    },
    async getTransferPdfData(transfer) {
      if (this.hasCompleteTransferPdfData(transfer)) {
        return transfer
      }

      if (!transfer || !transfer.ID_Transfer) {
        return transfer
      }

      try {
        const transferFromDb = await this.$API.inventoryTransfer.getOneTransfer(
          transfer.ID_Transfer
        )

        return {
          ...transfer,
          ...transferFromDb,
        }
      } catch (error) {
        console.warn(
          'No se pudo recargar el traspaso para exportar el PDF:',
          error
        )
        return transfer
      }
    },
    htmlToPlainText(html) {
      if (!html) {
        return ''
      }

      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html

      return (tempDiv.textContent || tempDiv.innerText || '').replace(/\s+/g, ' ').trim()
    },
    async exportCreatedTransferPdf(transferPayload) {
      this.loading = true

      try {
        const transfer = await this.getTransferPdfData(transferPayload)

        if (!transfer) {
          throw new Error('No se encontró información del traspaso creado')
        }

        const user = JSON.parse(localStorage.getItem('user')) || {}
        const branch = user.branch
        const business = user.businessid
        const businessResponse = await this.$API.branches.findSpecificBranch({
          branch,
          business,
        })
        const businessInfo = Array.isArray(businessResponse)
          ? businessResponse[0] || {}
          : businessResponse || {}

        let logoImg = null
        if (businessInfo.BusinessLogoPath) {
          try {
            const { imageBase64 } = await this.$API.utilities.getImageInBase64({
              file: businessInfo.BusinessLogoPath,
            })
            logoImg = imageBase64
          } catch (error) {
            logoImg = null
            console.warn('No se pudo cargar el logo en base64:', error.message)
          }
        }

        const [jsPDFModule, autoTableModule] = await Promise.all([
          import('jspdf'),
          import('jspdf-autotable'),
        ])
        const jsPDF = jsPDFModule.jsPDF || jsPDFModule.default
        const autoTable = autoTableModule.default
        const doc = new jsPDF('p', 'mm', 'a4')
        const pageWidth = doc.internal.pageSize.getWidth()
        let y = 12

        if (logoImg) {
          doc.addImage(logoImg, 'PNG', 10, 8, 38, 18)
        }

        doc.setFontSize(10)
        doc.setFont(undefined, 'bold')
        doc.text(businessInfo?.BusinessName || '', 12, 30)
        doc.setFont(undefined, 'normal')

        const isSolicitud = Boolean(transfer.RequestDate)
        let yInfo = 35

        doc.setFontSize(10)
        doc.setFont(undefined, 'bold')
        doc.text(
          'Fecha de impresión: ' + new Date().toLocaleDateString(),
          pageWidth - 12,
          15,
          { align: 'right' }
        )
        doc.text(
          isSolicitud
            ? 'ID Solicitud: ' + (transfer.ID_Request || '')
            : 'ID Transferencia: ' + (transfer.ID_Transfer || ''),
          pageWidth - 12,
          21,
          { align: 'right' }
        )
        doc.setLineWidth(0.3)
        doc.line(10, yInfo + 2, pageWidth - 10, yInfo + 2)
        y = yInfo + 8
        doc.setFontSize(13)
        doc.setFont(undefined, 'bold')
        doc.text('Transferencia de Inventario', pageWidth / 2, y, {
          align: 'center',
        })
        y += 8

        doc.setFontSize(10)
        doc.setFont(undefined, 'normal')

        const encabezado = [
          `Almacén Origen: ${transfer.OriginWarehouse || ''}`,
          `Destino: ${transfer.DestinyWarehouse || ''}`,
        ]

        if (transfer.ReqName) {
          encabezado.push(`Usuario Solicita: ${transfer.ReqName}`)
        }

        if (transfer.userName) {
          encabezado.push(`Usuario Aprobación: ${transfer.userName}`)
        }

        if (transfer.RequestDate) {
          encabezado.push(`Fecha Solicitud: ${transfer.RequestDate}`)
        }

        if (transfer.DateTransfer) {
          encabezado.push(`Fecha Aprobación: ${transfer.DateTransfer}`)
        } else if (!isSolicitud && transfer.TransferDate) {
          encabezado.push(`Fecha Aprobación: ${transfer.TransferDate}`)
        }

        encabezado.forEach((line) => {
          doc.text(line, 12, y)
          y += 6
        })

        if (transfer.Comments) {
          const plainTextComments = this.htmlToPlainText(transfer.Comments)

          if (plainTextComments) {
            const maxWidth = pageWidth - 24
            const lines = doc.splitTextToSize(
              `Comentarios: ${plainTextComments}`,
              maxWidth
            )

            lines.forEach((line) => {
              doc.text(line, 12, y)
              y += 6
            })
          }
        }

        y += 2

        const detalles = Array.isArray(transfer.details) ? transfer.details : []
        let tableColumns = [
          { header: 'ID Producto', dataKey: 'ID_Item' },
          { header: 'Código alterno', dataKey: 'ItemBarCode' },
          { header: 'Nombre', dataKey: 'ItemName' },
          { header: 'Cantidad Solicitada', dataKey: 'CantidadSolicitada' },
          { header: 'Costo Promedio', dataKey: 'CostoPromedio' },
          {
            header: 'Nueva existencia (Origen)',
            dataKey: 'ItemCurrentQuantityOrigin',
          },
          {
            header: 'Nueva existencia (Destino)',
            dataKey: 'StockDestinoResultante',
          },
          { header: 'Total', dataKey: 'TotalPrecioPromedio' },
        ]
        if(this.isCarsem){
          tableColumns = [
            { header: 'ID Producto', dataKey: 'ID_Item' },
            { header: 'Código alterno', dataKey: 'ItemBarCode' },
            { header: 'Nombre', dataKey: 'ItemName' },
            { header: 'Cantidad Solicitada', dataKey: 'CantidadSolicitada' },
            {
              header: 'Nueva existencia (Origen)',
              dataKey: 'ItemCurrentQuantityOrigin',
            },
            {
              header: 'Nueva existencia (Destino)',
              dataKey: 'StockDestinoResultante',
            },
          ]
        }
        const rows = detalles.map((item) => {
          const cantidad = parseFloat(item.CantidadSolicitada || 0)
          const costoPromedio = parseFloat(item.CostoPromedio || 0)
          const totalPrecioPromedio = cantidad * costoPromedio
          if(this.isCarsem){
            return {
              ID_Item: item.ID_Item,
              ItemBarCode: item.ItemBarCode || '',
              ItemName: item.ItemName || '',
              CantidadSolicitada: item.CantidadSolicitada || 0,
              ItemCurrentQuantityOrigin: item.StockOrigenResultante ?? 0,
              StockDestinoResultante: item.StockDestinoResultante ?? 0,
            }
          }else
            return {
              ID_Item: item.ID_Item,
              ItemBarCode: item.ItemBarCode || '',
              ItemName: item.ItemName || '',
              CantidadSolicitada: item.CantidadSolicitada || 0,
              CostoPromedio: `$${costoPromedio.toFixed(2)}`,
              TotalPrecioPromedio: `$${totalPrecioPromedio.toFixed(2)}`,
              ItemCurrentQuantityOrigin: item.StockOrigenResultante ?? 0,
              StockDestinoResultante: item.StockDestinoResultante ?? 0,
            };
        })

        const totalCantidad = detalles.reduce(
          (sum, item) => sum + parseFloat(item.CantidadSolicitada || 0),
          0
        )

        const totalPrecioProm = detalles.reduce((sum, item) => {
          const cantidad = parseFloat(item.CantidadSolicitada || 0)
          const costoPromedio = parseFloat(item.CostoPromedio || 0)
          return sum + cantidad * costoPromedio
        }, 0)

        autoTable(doc, {
          startY: y,
          head: [tableColumns.map((col) => col.header)],
          body: rows.map((row) => tableColumns.map((col) => row[col.dataKey])),
          styles: { fontSize: 9, cellPadding: 1.5 },
          headStyles: {
            fillColor: [128, 128, 128],
            textColor: 255,
            halign: 'center',
          },
          bodyStyles: { valign: 'top' },
          tableWidth: 'auto',
          columnStyles: {
            0: { cellWidth: 'auto', halign: 'center' },
            1: { cellWidth: 'auto', halign: 'center' },
            2: { cellWidth: 'auto', halign: 'center' },
            3: { cellWidth: 'auto', halign: 'center' },
            4: { cellWidth: 'auto', halign: 'center' },
            5: { cellWidth: 'auto', halign: 'center' },
            6: { cellWidth: 'auto', halign: 'center' },
            7: { cellWidth: 'auto', halign: 'center' },
          },
          theme: 'grid',
          foot: [
            [
              {
                content: 'TOTAL:',
                colSpan: 3,
                styles: { halign: 'right', fontStyle: 'bold' },
              },
              {
                content: totalCantidad.toFixed(2),
                styles: { halign: 'center', fontStyle: 'bold' },
              },
              { content: '', styles: { halign: 'center', fontStyle: 'bold' } },
              { content: '', styles: { halign: 'center', fontStyle: 'bold' } },
              { content: '', styles: { halign: 'center', fontStyle: 'bold' } },
              {
                content: `$${totalPrecioProm.toFixed(2)}`,
                styles: { halign: 'center', fontStyle: 'bold' },
              },
            ],
          ],
          footStyles: {
            fillColor: [240, 240, 240],
            textColor: 20,
            fontStyle: 'bold',
            fontSize: 10,
          },
        })

        doc.setFontSize(10)

        const pageCount = doc.internal.getNumberOfPages()
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          doc.setFontSize(8)
          doc.text(
            `Página ${i} de ${pageCount}`,
            pageWidth - 20,
            doc.internal.pageSize.getHeight() - 8,
            { align: 'right' }
          )
        }

        window.open(doc.output('bloburl'), '_blank')
      } catch (error) {
        this.showAlert(
          'danger',
          'Error',
          'No se pudo exportar el PDF: ' + error.message
        )
      } finally {
        this.loading = false
      }
    },
    deselectAll() {
      this.inventory.forEach((element) => {
        if (element.ItemCurrentQuantity > 0 && element.Warehouse == this.form.warehouseOrigin) {
          element.checkbox = false
        }
      })
      this.showdeselect = false
      this.counter = 0
    },
    selectAll() {
      let availableProductsCount = 0
      this.inventory.forEach((element) => {
        if (element.ItemCurrentQuantity > 0 && element.Warehouse == this.form.warehouseOrigin) {
          element.checkbox = true
          availableProductsCount++
        }
      })
      this.counter = availableProductsCount
      this.showdeselect = true
    },
    getAllPriceList() {
      this.$API.priceList.priceList(this.filterProducts).then((response) => {
        this.priceList = response
      })
    },
    getProducts() {
      this.$API.priceList
        .getProductsList(this.filterProducts)
        .then((response) => {
          this.productsToBill = response
          this.productsToShowOld = response
          // this.productsToShowWarehouse = response
          // add a checkbox to each product
          this.productsToBill.forEach((product) => {
            product.checkbox = false
          })
        })
    },
    getInventory() {
      this.$API.products
        .getProductInventoryHistory()
        .then(response => {
          this.inventory = response
          this.productsToShowWarehouse = response
          // add a checkbox to each product
          this.inventory.forEach((product) => {
            product.checkbox = false
          })
          // Solo llamar fillDataFromTransfer si NO viene de una solicitud
          if (!this.transferRequestData || this.transferRequestData.length === 0) {
            this.fillDataFromTransfer()
          }
          // Si hay almacén de origen o destino seleccionado, filtrar inmediatamente
          if (this.form.warehouseOrigin || this.form.warehouseDestination) {
            this.getItemsFromWarehouseOrigin()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInventoryListAll() {
      this.$API.products
        .getProductInventory()
        .then(response => {
          this.inventory = response
          this.productsToShowWarehouse = response
          // add a checkbox to each product
          this.inventory.forEach((product) => {
            product.checkbox = false
          })
          this.fillDataFromTransfer()
          // Si hay almacén de origen o destino seleccionado, filtrar inmediatamente
          if (this.form.warehouseOrigin || this.form.warehouseDestination) {
            this.getItemsFromWarehouseOrigin()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getAllProducts() {
      this.$API.products.getProductsHistory(this.search)
        .then(response => {
          this.products = response
          this.AllData = response
        })
    },
    getAllProviders() {
      let search = {}
      search.business =
        JSON.parse(localStorage.getItem('user')).businessid || ''
      search.branch = JSON.parse(localStorage.getItem('user')).branch || ''
      this.$API.providers.getProviders(search).then((response) => {
        this.providers = response
      })
    },
    showProduct() {
      this.counter = 0
      this.inventory.forEach((element) => {
        if (element.checkbox && element.ItemCurrentQuantity > 0 && element.Warehouse == this.form.warehouseOrigin) {
          this.counter++
        }
      })
    },
    getFamilies() {
      this.$API.itemtypes.getFamilies().then((response) => {
        this.families = response
        this.columsConfig[0].options = response.map((fam) => ({name: fam.name, value: fam.id}));
      })
    },
    getCategories() {
      this.$API.itemtypes.getCategories().then((response) => {
        this.categories = response
        this.columsConfig[1].options = response.map((cat) => ({name: cat.name, value: cat.id, parent_id: cat.id_family}));
      })
    },
    getSubs() {
      this.$API.itemtypes.getSubs().then((response) => {
        this.subcategories = response
        this.columsConfig[2].options = response.map((sub) => ({name: sub.name, value: sub.id, parent_id: sub.id_cat}));
      })
    },
    handleChanged(priceListSelected) {
      this.showPriceList = false
      this.loading = true
      if (!priceListSelected.Active) {
        this.showAlert(
          'warning',
          'Advertencia',
          'Debe existir almenos una lista de precios activa'
        )
        this.priceList = this.priceList.map((i) => {
          if (i.id == priceListSelected.id) {
            i.Active = true
          }

          return i
        })
        return
      }
      let data = {
        id: priceListSelected.id,
      }
      this.$API.priceList
        .changuePriclistSelected(data)
        .then(() => {
          this.loading = false
          this.showAlert(
            'success',
            'Exito',
            'Lista de precios activada con exito'
          )
          this.$store.commit('setChanguePriceList', true)
          this.cleanData()
          this.getAllPriceList()
        })
        .catch(() => {
          this.loading = false
          this.showAlert(
            'danger',
            'Error',
            'Error al activar la lista de precios'
          )
          this.getAllPriceList()
        })
    },
    showProductOld(data) {
      this.update = true
      let params = {
        business:
          JSON.parse(localStorage.getItem('user')).businessid != undefined
            ? JSON.parse(localStorage.getItem('user')).businessid
            : 0,
        branch:
          JSON.parse(localStorage.getItem('user')).branch != undefined
            ? JSON.parse(localStorage.getItem('user')).branch
            : 0,
        PriceListName: data.data.id,
      }

      this.$API.priceList.itemsFromList(params).then((response) => {
        (this.productsToShow = response.map((i) => {
          return {
            _uuid: getUUIDv4(),
            ID_Item: i.ID_Item,
            ItemName: i.ItemName,
            ItemOriginalPrice: i.ItemOriginalPrice,
            ItemPriceDiscountPercent: i.ItemPriceDiscountPercent,
            ItemPriceDiscountAmount: i.ItemPriceDiscountAmount,
            ItemNewPrice: i.ItemNewPrice,
            ItemCurrency: i.ItemCurrency,
            ID_Branch: i.ID_Branch,
            IsGlobalBranch: i.IsGlobalBranch,
            ID_Business: i.ID_Business,
            Active: data.data.Active,
          }
        })),
          (this.form.pricelistname = data.data.id)
        this.form.Active = data.data.Active
      })
    },
    removeRow(data) {
      // Eliminar usando el UUID único en lugar del índice de fila
      const uuidToRemove = data.data._uuid
      const indexToRemove = this.productsToShow.findIndex(item => item._uuid === uuidToRemove)
      
      if (indexToRemove !== -1) {
        this.productsToShow.splice(indexToRemove, 1)
        // También eliminar de la lista de respaldo para que no vuelva a aparecer al filtrar
        this.saveProductsToShow()
      } else {
        console.error('No se pudo encontrar el producto a eliminar con UUID:', uuidToRemove)
      }
    },
    resetData() {
      this.productsToShow = []
      this.form.pricelistname = null
      this.update = false
      this.getInventory()
    },
    changeDis(event, data) {
      let OriginalPrice = parseFloat(data.data.ItemOriginalPrice)

      data.data.ItemPriceDiscountPercent = (
        (parseFloat(event.target.value) / OriginalPrice) *
        100
      ).toFixed(2)

      data.data.ItemNewPrice = parseFloat(
        OriginalPrice - parseFloat(event.target.value)
      ).toFixed(2)

      this.productsToShow = this.productsToShow.map((i) => {
        if (i.ID_Inventory == data.data.ID_Inventory) {
          i.ItemPriceDiscountPercent = data.data.ItemPriceDiscountPercent
          i.ItemPriceDiscountAmount = data.data.ItemPriceDiscountAmount
          i.ItemNewPrice = data.data.ItemNewPrice
        }

        return i
      })
    },
    changeDisP(event, data) {
      let OriginalPrice = parseFloat(data.data.ItemOriginalPrice)

      data.data.ItemPriceDiscountAmount = (
        (parseFloat(event.target.value) / 100) *
        OriginalPrice
      ).toFixed(2)

      data.data.ItemNewPrice = parseFloat(
        OriginalPrice - parseFloat(data.data.ItemPriceDiscountAmount)
      ).toFixed(2)

      this.productsToShow = this.productsToShow.map((i) => {
        if (i.ID_Inventory == data.data.ID_Inventory) {
          i.ItemPriceDiscountPercent = data.data.ItemPriceDiscountPercent
          i.ItemPriceDiscountAmount = data.data.ItemPriceDiscountAmount
          i.ItemNewPrice = data.data.ItemNewPrice
        }

        return i
      })

    },
    async acceptAlert() {
      const options = this.alert.options
      this.alert.show = false

      try {
        if (options && typeof options.alertAccept === 'function') {
          await options.alertAccept()
        } else if (options == 'clientLinkList') {
          this.addPriceListToClient()
        }
      } finally {
        this.alert.options = null
      }
    },
    cleanData() {
      this.productsToShow = []
      this.productsToShowFilter = []
      this.filter = {
        family: null,
        category: null,
        subcategory: null,
        providers: null,
      }
      this.search = {
        filter: null,
        products: []
      }
      // Limpiar todos los campos del formulario
      this.form = {
        warehouseDestination: null,
        warehouseOrigin: null,
        typeOfTransfer: null,
        Active: false,
        notes: null,
        comments: null,
        pricelistname: null
      }
      // Establecer fecha actual en formato dd/mm/yyyy
      const today = new Date()
      const day = String(today.getDate()).padStart(2, '0')
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const year = today.getFullYear()
      this.date = `${day}/${month}/${year}`
      // Limpiar otros campos
      this.update = false
      this.transferRequestActive = false
      this.requestStatus = null
      this.requestId = null
      this.counter = 0
      this.showdeselect = false
      // Limpiar la lista de inventario ya que no hay almacén seleccionado
      this.inventory = []
      // Limpiar checkboxes del inventario completo
      if (this.productsToShowWarehouse && this.productsToShowWarehouse.length > 0) {
        this.productsToShowWarehouse.forEach((product) => {
          product.checkbox = false
        })
      }
      // Limpiar editor Quill
      this.$nextTick(() => {
        if (this.$refs.quillEditor && this.$refs.quillEditor.quill) {
          this.$refs.quillEditor.quill.setText('')
        }
      })
      this.getAllPriceList()
    },
    searchForNonStockOnDetails() {
      for (const element of this.productsToShow) {
        const { StockResult } = element;
        if (StockResult < 0) {
          return true;
        }
      }
      return false;
    },
    addNewTransfer() {
      try {

        this.loading = true
        if (!this.valid) {
          this.showAlert(
            'warning',
            'Advertencia',
            'Debe llenar los campos requeridos'
          )
          return
        }

        if (this.searchForNonStockOnDetails()) {
            this.showAlert(
              "warning",
              "Advertencia",
              "Uno o mas elementos de esta solictud no tiene el Stock suficiente para realizar el traspaso, revisar los elementos con cantidades negativas en la columna nueva existencia."
            );
            this.loading = false
          return;
        }

        if (!this.productsToShow || this.productsToShow.length === 0) {
          this.loading = false
          this.showAlert(
            'warning',
            'Advertencia',
            'Debe agregar al menos un producto al traspaso'
          )
          return
        }
        // Validar que todos los productos tengan cantidad a transferir mayor a 0
        const productsWithoutAmount = this.productsToShow.filter(product => !product.Amount || product.Amount <= 0)
        if (productsWithoutAmount.length > 0) {
          this.loading = false
          this.showAlert(
            'warning',
            'Advertencia',
            `Todos los productos deben tener una cantidad a transferir mayor a 0. ${productsWithoutAmount.length} producto(s) sin cantidad válida.`
          )
          return
        }
        this.$refs['dxDataGridTransfer'].instance.refresh();
        const { warehouseOrigin, warehouseDestination, comments } = this.form

        const inventorytransfer = {
          TransferDate: fixFormatDate(this.date),
          OriginID_Warehouse: warehouseOrigin,
          DestinyID_Warehouse: warehouseDestination,
          ID_User: JSON.parse(localStorage.getItem('user')).id,
          Comments: comments,
          ID_Request: this.requestId,
          RequestStatus: this.requestStatus,
        }

        // Limpiar y normalizar los datos para que sean idénticos a los del modal
        const inventorytransferdetails = this.productsToShow.map(product => {
          const cleanProduct = { ...product }
          
          // ID_Item ya viene en el producto, no necesita mapeo adicional
          
          // Normalizar ID_ItemBatch: convertir string "null" a null real
          if (cleanProduct.ID_ItemBatch === "null") {
            cleanProduct.ID_ItemBatch = null
          }
          
          // Asegurar que las existencias estén presentes
          if (!cleanProduct.ExistenciaOrigen && cleanProduct.ItemCurrentQuantity !== undefined) {
            cleanProduct.ExistenciaOrigen = cleanProduct.ItemCurrentQuantity
          }
          
          if (!cleanProduct.NuevaExistenciaOrigen && cleanProduct.StockResult !== undefined) {
            cleanProduct.NuevaExistenciaOrigen = cleanProduct.StockResult
          }
          
          if (!cleanProduct.ExistenciaDestino && cleanProduct.ItemCurrentQuantityAtDestination !== undefined) {
            cleanProduct.ExistenciaDestino = cleanProduct.ItemCurrentQuantityAtDestination
          }
          
          if (!cleanProduct.NuevaExistenciaDestino && cleanProduct.StockResultAtDestination !== undefined) {
            cleanProduct.NuevaExistenciaDestino = cleanProduct.StockResultAtDestination
          }
          
          // Eliminar campos UI que no existen en productos del modal
          delete cleanProduct.checkbox
          delete cleanProduct.displayText
          delete cleanProduct.canAdd
          delete cleanProduct.disabled
          
          return cleanProduct
        })

        console.log('Datos a enviar:', {
          inventorytransfer,
          inventorytransferdetails
        })

        const body = {
          inventorytransfer,
          inventorytransferdetails
        }

        this.$API.inventoryTransfer.addNewTransfer(body)
          .then((response) => {
            const createdTransfer = this.resolveTransferResponse(response)

            this.loading = false
            const warning = response && response.externalStoreSyncWarning
            this.showAlert(
              warning ? 'warning' : 'successWithCallback',
              warning ? 'Traspaso guardado' : 'Exito',
              warning ? 'Traspaso creado con exito. ' + warning : 'Traspaso creado con exito',
              {
                alertAccept: async () => {
                  await this.exportCreatedTransferPdf(createdTransfer)
                },
              }
            )
            this.resetData()
            this.cleanData()
            this.$store.commit('transferData/setTransfers', [])
          })
          .catch(error => {
            this.loading = false
            console.error('Error completo:', error)
            console.error('Error response:', error.response)
            this.showAlert(
              'danger',
              'Error',
              'Error al guardar el traspaso: ' + (error.response?.data || error.message || error || 'Error desconocido')
            )
          })
      } catch (error) {
        this.loading = false
        console.error('Error en try-catch:', error)
        this.showAlert(
          'danger',
          'Error',
          'Error al guardar el traspaso: ' + (error.message || error || 'Error desconocido')
        )
      }
    },
    addNewTransferRequest(requestStatus = 0) {
      try {

        this.loading = true
        if (!this.valid) {
          this.showAlert(
            'warning',
            'Advertencia',
            'Debe llenar los campos requeridos'
          )
          return
        }
        if (!this.productsToShow || this.productsToShow.length === 0) {
          this.loading = false
          this.showAlert(
            'warning',
            'Advertencia',
            'Debe agregar al menos un producto a la solicitud de traspaso'
          )
          return
        }
        // Validar que todos los productos tengan cantidad a transferir mayor a 0
        const productsWithoutAmount = this.productsToShow.filter(product => !product.Amount || product.Amount <= 0)
        if (productsWithoutAmount.length > 0) {
          this.loading = false
          this.showAlert(
            'warning',
            'Advertencia',
            `Todos los productos deben tener una cantidad a transferir mayor a 0. ${productsWithoutAmount.length} producto(s) sin cantidad válida.`
          )
          return
        }
        this.$refs['dxDataGridRequest'].instance.refresh();
        const { warehouseOrigin, warehouseDestination, comments } = this.form

        const inventorytransferrequest = {
          RequestDate: fixFormatDate(this.date),
          OriginID_Warehouse: warehouseOrigin,
          DestinyID_Warehouse: warehouseDestination,
          ID_User: JSON.parse(localStorage.getItem('user')).id,
          Comments: comments,
          RequestStatus: requestStatus // Agregar el estado de la solicitud
        }

        // Normalizar los datos de la solicitud de traspaso
        const inventorytransferrequestdetails = this.productsToShow.map(product => {
          const cleanProduct = { ...product }
          
          // ID_Item ya viene en el producto, no necesita mapeo adicional
          
          // Normalizar ID_ItemBatch: convertir string "null" a null real
          if (cleanProduct.ID_ItemBatch === "null") {
            cleanProduct.ID_ItemBatch = null
          }
          
          // Asegurar que las existencias estén presentes
          if (!cleanProduct.ExistenciaOrigen && cleanProduct.ItemCurrentQuantity !== undefined) {
            cleanProduct.ExistenciaOrigen = cleanProduct.ItemCurrentQuantity
          }
          
          if (!cleanProduct.NuevaExistenciaOrigen && cleanProduct.StockResult !== undefined) {
            cleanProduct.NuevaExistenciaOrigen = cleanProduct.StockResult
          }
          
          if (!cleanProduct.ExistenciaDestino && cleanProduct.ItemCurrentQuantityAtDestination !== undefined) {
            cleanProduct.ExistenciaDestino = cleanProduct.ItemCurrentQuantityAtDestination
          }
          
          if (!cleanProduct.NuevaExistenciaDestino && cleanProduct.StockResultAtDestination !== undefined) {
            cleanProduct.NuevaExistenciaDestino = cleanProduct.StockResultAtDestination
          }
          
          return cleanProduct
        })

        const body = {
          inventorytransferrequest,
          inventorytransferrequestdetails
        }

        const successMessage = requestStatus === 3 
          ? 'Solicitud de Traspaso enviada con éxito' 
          : 'Solicitud de Traspaso creada con éxito'

        this.$API.inventoryTransfer.addNewTransferRequest(body)
          .then(() => {
            this.loading = false
            this.showAlert(
              'success',
              'Exito',
              successMessage
            )
            this.resetData()
            this.cleanData()
          })
          .catch(error => {
            this.loading = false
            console.log(error)
            this.showAlert(
              'danger',
              'Error',
              'Error al guardar la Solicitud de Traspaso' + error.message
            )
          })
      } catch (error) {
        this.loading = false
        console.log(error)
        this.showAlert(
          'danger',
          'Error',
          'Error al guardar la Solicitud de Traspaso' + error.message
        )
      }
    },
    getWarehouse() {
      let idbusiness = JSON.parse(localStorage.getItem("user")).businessid || ""
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || ""
      this.filterWarehouses.branch = idbranch
      this.filterWarehouses.business = idbusiness
      this.$API.warehouse.getWarehousesByBusiness({...this.filterWarehouses, notShowReserve: 1})
        .then(response => {
          this.warehouses = response
        })
    },
    getItemsFromWarehouseOrigin() {
      // Filtrar productos solo del almacén de origen
      if (this.form.warehouseOrigin) {
        this.inventory = this.productsToShowWarehouse.filter(product => {
          return product.Warehouse == this.form.warehouseOrigin
        })
      } else {
        this.inventory = []
      }
      
      // add a checkbox to each product
      this.inventory.forEach((product) => {
        if (product.checkbox === undefined) {
          product.checkbox = false
        }
      })
    },
    getItemsFilteredFromWarehouseOrigin() {
      this.inventoryFiltered = JSON.parse(JSON.stringify(this.inventory)).filter(product => {
        return product.Warehouse == this.form.warehouseOrigin
      })
    },
    async fillDataFromTransferOptimized() {
      if (!this.transferRequestData || this.transferRequestData.length === 0) {
        console.error("transferRequestData es nulo o vacío")
        return
      }

      console.log("Transfer Request Data:", this.transferRequestData);

      const {
        OriginID_Warehouse,
        DestinyID_Warehouse,
        OriginWarehouse,
        DestinyWarehouse,
        RequestDate,
        Comments,
        ID_Request,
        RequestStatus,
        details
      } = JSON.parse(JSON.stringify(this.transferRequestData))

      // Configurar almacenes y otros datos del formulario
      this.form.warehouseOrigin = OriginID_Warehouse
      this.form.warehouseDestination = DestinyID_Warehouse
      this.form.comments = Comments
      this.requestId = ID_Request
      
      // Establecer la fecha de la solicitud
      if (RequestDate) {
        this.date = RequestDate
      }
      
      // Status of the order
      // Pendiente == 0
      // Realizado == 1
      // Cancelado == 2
      if(RequestStatus == 0){
        this.requestStatus = 1 
      }else{
        this.requestStatus = RequestStatus
      }

      // Mapear los detalles directamente usando los datos que ya vienen en la solicitud
      this.productsToShow = details.map(detail => ({
        // Generar UUID único para cada producto
        _uuid: getUUIDv4(),
        
        // Datos originales del detalle
        ID_Request: detail.ID_Request,
        ID_Inventory: detail.ID_Inventory,
        ID_Business: detail.ID_Business,
        ID_Branch: detail.ID_Branch,
        ID_Item: detail.ID_Item,
        ItemName: detail.ItemName,
        
        // Cantidad a transferir
        Amount: detail.CantidadSolicitada || detail.Amount || 0,
        
        // Costo promedio
        CostoPromedio: parseFloat(detail.CostoPromedio) || 0,
        
        // Lote/Batch
        ID_ItemBatch: detail.Lote,
        Lote: detail.Lote,
        
        // Almacén de origen
        Warehouse: OriginID_Warehouse,
        WarehouseName: OriginWarehouse || '',
        
        // Stock en origen (datos actuales de la solicitud)
        ItemCurrentQuantity: parseFloat(detail.ExistenciaOrigen) || 0,
        StockResult: parseFloat(detail.NuevaExistenciaOrigen) || 0,
        ExistenciaOrigen: parseFloat(detail.ExistenciaOrigen) || 0,
        NuevaExistenciaOrigen: parseFloat(detail.NuevaExistenciaOrigen) || 0,
        
        // Stock en destino (datos de la solicitud)
        warehouseAtDestination: DestinyWarehouse || '',
        ItemCurrentQuantityAtDestination: parseFloat(detail.ExistenciaDestino) || 0,
        StockResultAtDestination: parseFloat(detail.NuevaExistenciaDestino) || 0,
        ExistenciaDestino: parseFloat(detail.ExistenciaDestino) || 0,
        NuevaExistenciaDestino: parseFloat(detail.NuevaExistenciaDestino) || 0,
        ID_ItemBatchAtDestination: detail.Lote || 'Por defecto',
        
        // Campos de sistema
        SystemDateInsert: detail.SystemDateInsert,
        SystemDateUpdate: detail.SystemDateUpdate
      }))

      // Saving added products for transfer
      this.saveProductsToShow()

      // Cargar inventario en segundo plano solo si no está cargado
      this.$nextTick(() => {
        if (!this.inventory || this.inventory.length === 0) {
          this.getInventoryInBackground()
        }
      })
      
      if(this.reloadState){
        this.setReload(false)
        this.$nextTick(() => {
          this.$refs['dxDataGridRequest']?.instance.reload()
        })
        console.log("reload")
        console.log(this.transferRequestData)
        if(this.transferRequestData.tab == 'request')
          this.tab = 'tab-1'
      }
    },
    getInventoryInBackground() {
      // Cargar inventario en segundo plano sin bloquear
      this.$API.products
        .getProductInventoryHistory()
        .then(response => {
          this.inventory = response
          this.productsToShowWarehouse = response
          this.inventory.forEach((product) => {
            product.checkbox = false
          })
        })
        .catch(error => {
          console.log('Error cargando inventario en background:', error)
        })
    },
    async updateDestinationInfo() {
      // Actualizar información del almacén destino en segundo plano
      if (!this.form.warehouseDestination) return

      const warehouseName = this.warehouses.find(w => w.ID_Warehouse === this.form.warehouseDestination)?.Warehouse || ''
      
      for (let i = 0; i < this.productsToShow.length; i++) {
        const product = this.productsToShow[i]
        try {
          const destInfo = await this.$API.inventoryTransfer.infoProductAtDestination({
            warehouse: this.form.warehouseDestination,
            id_itembatch: product.ID_ItemBatch,
            id_item: product.ID_Item,
          })
          
          this.$set(this.productsToShow, i, {
            ...product,
            warehouseAtDestination: warehouseName,
            ItemCurrentQuantityAtDestination: destInfo.ItemCurrentQuantity || 0,
            StockResultAtDestination: (destInfo.ItemCurrentQuantity || 0) + (product.Amount || 0),
            ID_ItemBatchAtDestination: destInfo.ID_ItemBatch || 'Por defecto'
          })
        } catch (error) {
          console.log('Error obteniendo info del destino:', error)
        }
      }
      
      // Refrescar el grid después de actualizar
      this.$nextTick(() => {
        if (this.$refs['dxDataGridTransfer']) {
          this.$refs['dxDataGridTransfer'].instance.refresh()
        }
        if (this.$refs['dxDataGridRequest']) {
          this.$refs['dxDataGridRequest'].instance.refresh()
        }
      })
    },
    async updateDestinationAndRefresh() {
      // Método mejorado que actualiza destino y recalcula stocks
      await this.updateDestinationInfo()
      
      // Recalcular StockResult para cada producto basado en el stock actual
      this.productsToShow = this.productsToShow.map(product => ({
        ...product,
        // Preservar el UUID existente o generar uno nuevo si no existe
        _uuid: product._uuid || getUUIDv4(),
        StockResult: (product.ItemCurrentQuantity || 0) - (product.Amount || 0)
      }))
      
      this.saveProductsToShow()
    },
    fillDataFromTransfer() {

      if (this.transferRequestData.length == 0) {
        console.error("transferRequestData es nulo")
        return
      }

      const {
        OriginID_Warehouse,
        DestinyID_Warehouse,
        ID_Request,
        RequestStatus,
        details
      } = 
        JSON.parse(JSON.stringify(this.transferRequestData))

      // Using a map to get each detail
      const setCurentQuantity = details.map((detail) => {

        const { ItemCurrentQuantity, ItemMeasureUnit } = this.inventory.find((item) =>{
          return item.ID_Inventory === detail.ID_Inventory 
        }
        );

        return {
          _uuid: getUUIDv4(),
          ...detail,
          ItemCurrentQuantity,
          ItemMeasureUnit
        }
      })

      this.form.warehouseOrigin = OriginID_Warehouse
      this.form.warehouseDestination = DestinyID_Warehouse
      this.productsToShow = setCurentQuantity
      this.requestId = ID_Request
      // Status of the order
      // Pendiente == 0
      // Realizado == 1
      // Cancelado == 2
      if(RequestStatus == 0){
        this.requestStatus = 1 
      }else{
        this.requestStatus = RequestStatus
      }
      
      this.getItemsFromWarehouseOrigin()

      // Saving added products for transfer
      this.saveProductsToShow()
      
      if(this.reloadState){
        this.setReload(false)
        this.$refs['dxDataGridRequest'].instance.reload();
        console.log("reload");
        console.log(this.transferRequestData);
        if(this.transferRequestData.tab == 'request')
        this.tab = 'tab-1'
      }
    },
    filterHandler(response) {
      this.productsToShow = response
    },
    filterTransferProduct({filter, products}){

      let filteredProducts = products.filter((product) => 
        product.ID_Item.toString().includes(filter) ||
        product.ItemName.includes(filter) ||
        product.Amount.toString().includes(filter) ||
        product.ItemCurrentQuantity.toString().includes(filter)
      );

      return new Promise((resolve) => {
          resolve(filteredProducts)
      })
    },
    saveProductsToShow(){
      this.productsToShowFilter = JSON.parse(JSON.stringify(this.productsToShow))
      this.search = {
          products: JSON.parse(JSON.stringify(this.productsToShowFilter))
       }
    },
    getProductsToShow(){
       this.productsToShow = JSON.parse(JSON.stringify(this.productsToShowFilter))
    }
  },
}
</script>

<style scoped>
.fs-10 {
  font-size: 10px !important;
}

.input-group-prepend {
  display: flex;
}

.input-group-prepend {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 3px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0 5px;
  font-size: 14px;
  line-height: 1;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input-group>.form-control {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}

.box {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  background-color: white;

  border-radius: 15px;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.btnclean {
  background-color: #f29d35 !important;
  color: white;
}

.btn-add {
  background-color: #3498db !important;
  color: white;
}

.btnsave {
  background-color: #3498db !important;
  color: white;
}

.tabs {
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabsB {
  width: 100%;
  padding: 10px;
  background-color: #1976d2;
  color: white;
  border-radius: 15px;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #F29D35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;

  border-radius: 10px;

}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;

  border-radius: 10px;

}

.tabsB:hover {
  background-color: #0d47a1;
  cursor: pointer;
}

.tabsN {
  padding: 5px;
  background-color: rgba(60, 60, 60, 1);
  color: white;
  border-radius: 15px;
}

.icon-color {
  color: white
}

/* Estilos para centrar checkbox e iconos en la tabla */
.dx-datagrid-rowsview .dx-row .dx-command-select {
  text-align: center !important;
}

.dx-datagrid .dx-checkbox {
  margin: 0 auto !important;
}
</style>
